<template>
  <v-card height="820">
    <template v-if="experiment">
      <v-card-title>
        <span class="text-subtitle-1 font-weight-bold">
          {{ experiment.title }}
        </span>
        <span class="text-subtitle-2">
          {{ experiment.breed }} / {{ experiment.person }} /
          {{ dateFormat(new Date(experiment.start), 'YY年MM月DD日 hh:mm开始') }}

          {{ dateFormat(new Date(experiment.complete), 'MM月DD日 hh:mm结束') }}
        </span>
        <v-spacer></v-spacer>
        <v-switch
          v-model="markedOnly"
          class="text-caption ma-0 pa-0"
          color="warning"
          hide-details
        >
          <template v-slot:label>
            <span class="text-caption">仅显示标注记录</span>
          </template>
        </v-switch>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="tab" grow>
          <v-tab>实验摘要</v-tab>
          <v-tab>实验过程</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="mt-2">
          <v-tab-item>
            <div class="text-body-2">
              {{ summary }}
            </div>
          </v-tab-item>
          <v-tab-item>
            <history-table :shortcuts="shortcuts"></history-table>
            <!-- <v-virtual-scroll
              :bench="2"
              :items="shortcuts"
              height="680"
              item-height="90"
            >
              <template v-slot:default="{ item }">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span
                        :class="
                          `text-body-2 ${
                            item.marked ? 'red--text' : 'black--text'
                          } font-weight-black`
                        "
                      >
                        {{ dateFormat(new Date(item.stime), 'MM-DD hh:mm') }}
                      </span>
                      <span class="text-caption">
                        /
                        {{ (item.stime - experiment.start) | distance }}
                      </span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <v-row class="ml-1 mt-0">
                        <v-col cols="3">
                          <span class="text-caption">
                            东侧风力 {{ item.wind2 }}
                          </span>
                        </v-col>
                        <v-col cols="3">
                          <span class="text-caption">
                            西侧风力 {{ item.wind1 }}
                          </span>
                        </v-col>
                        <v-col cols="3">
                          <span class="text-caption">
                            雨量 {{ item.rain | rainLabel }}
                          </span>
                        </v-col>
                        <v-col cols="3">
                          <span class="text-caption">
                            <v-btn icon="mdi-check">拍照图片</v-btn>
                          </span>
                        </v-col>
                      </v-row>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-virtual-scroll> -->
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </template>
  </v-card>
</template>
<script>
import { findExperimentSummaryById } from '@/api/experiment.js'
import { listShortcuts, listShortcutsMarked } from '@/api/shortcut.js'

import HistoryTable from './HistoryDetailTable.vue'
export default {
  props: {
    experiment: undefined
  },
  components: { HistoryTable },
  data() {
    return {
      tab: 0,
      summary: undefined,
      shortcuts: [],
      markedOnly: false
    }
  },
  filters: {
    rainLabel(val) {
      return ['停', '小', '中', '大', '特大'][val]
    },
    distance(offset) {
      offset = parseInt(offset / (1000 * 60))
      const minute = offset % 60
      const hour = parseInt((offset - minute) / 3600)
      if (hour > 0) {
        return `${hour}小时${minute}分钟`
      } else {
        return `${minute}分钟`
      }
    }
  },
  watch: {
    experiment: {
      immediate: true,
      handler: function(n, o) {
        console.log(n, '...', o)
        if (!n) return
        findExperimentSummaryById(n.id).then(resp => {
          console.log('summary=', resp)
          this.summary = resp
        })
        listShortcuts(n.id, 0).then(resp => {
          console.log('shortcuts=', resp)
          this.shortcuts = resp
        })
      }
    },
    markedOnly: {
      handler: function(n) {
        if (n) {
          listShortcutsMarked(this.experiment.id).then(resp => {
            this.shortcuts = resp
            console.log('shortcuts = ', resp)
          })
        } else {
          listShortcuts(this.experiment.id).then(resp => {
            this.shortcuts = resp
            console.log('shortcuts = ', resp)
          })
        }
        console.log(n)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/history/HistoryDetail.vue